import { STRAPI_URL } from "../env";

export interface UserSettings {
  tutorialCompleted?: boolean;
  setupSkipped?: boolean;
  skipChangedFieldDialog?: boolean;
}

export async function fetchUserSettings(): Promise<UserSettings | null> {
  try {
    const response = await fetch(`${STRAPI_URL}/bff-user-settings`, {
      credentials: "include",
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.status >= 400) {
      return null;
    }

    const status = (await response.json()) as UserSettings;
    return status;
  } catch {
    return null;
  }
}

export async function saveUserSettings({
  tutorialCompleted,
  setupSkipped,
  skipChangedFieldDialog,
}: {
  tutorialCompleted?: boolean;
  setupSkipped?: boolean;
  skipChangedFieldDialog?: boolean;
}): Promise<UserSettings | null> {
  try {
    const response = await fetch(`${STRAPI_URL}/bff-user-settings`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        tutorialCompleted,
        setupSkipped,
        skipChangedFieldDialog,
      }),
    });

    if (response.status >= 400) {
      return null;
    }

    const status = (await response.json()) as UserSettings;
    return status;
  } catch {
    return null;
  }
}
